import { OktaAuth } from "@okta/okta-auth-js";

const ISSUER = "https://clearstreet.okta.com/oauth2/default";

export function getOktaAuth(clientId: string) {
    return new OktaAuth({
        issuer: ISSUER,
        clientId,
        redirectUri: `${window.location.origin}/oauth2/callback`,
        scopes: ["openid", "email", "profile"],
    });
}

export function getStoredOktaClientId(): string | null {
    return localStorage.getItem("okta_client_id");
}

interface StartOktaSignInOptions {
    clientId: string;
    loginHint?: string;
}

export async function startOktaSignIn(
    options: StartOktaSignInOptions
): Promise<never> {
    const { clientId, loginHint } = options;
    localStorage.setItem("okta_client_id", clientId);
    const oktaAuth = getOktaAuth(clientId);
    await oktaAuth.signInWithRedirect({
        originalUri: window.location.href,
        ...(loginHint ? { loginHint } : {}),
    });
    throw new Error("Okta redirect did not occur as expected.");
}